export default __webpack_public_path__ + "static/media/Knitted_fabrics.c7149eb8.png";